import { ImageWithFallback } from '@blockworks/ui/image-with-fallback';

interface PriceTickerProps {
    title: string;
    priceChange: number;
    src: string;
}

const PriceTicker = ({ title, priceChange, src }: PriceTickerProps) => {
    const isPositive = priceChange > 0;

    return (
        <span
            className="inline-flex items-center justify-center bg-gray-100 rounded-full px-2 py-1 min-h-[28px]"
            role="text"
            aria-label={`${title} price changed by ${priceChange}%`}
        >
            <span className="mr-1">
                <ImageWithFallback src={src} alt={`${title} icon`} className="object-contain" width={14} height={14} />
            </span>
            <span className="font-bold text-xxs flex items-center justify-center">{title}</span>

            <span
                className={`ml-1 text-xxs flex items-center justify-center ${isPositive ? 'text-green-600' : 'text-red-600'}`}
            >
                {priceChange}%
            </span>
        </span>
    );
};

export default PriceTicker;
